import styled from "styled-components";

export const ModelGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 40px;
    padding: 60px 8%;
    background: #b5b09b;

    @media (max-width: 768px) {
        padding: 40px 5%;
        gap: 20px;
    }
`;

export const ModelCard = styled.div`
    overflow: hidden;
    border-radius: 20px;
    cursor: pointer;
    position: relative;

    max-width: 350px;
    margin: 0 auto;

    &:hover img {
        transform: scale(1.05);
    }
`;

export const ModelImage = styled.img`
    width: 100%;
    object-fit: cover;
    transition: transform 0.6s ease;
`;

export const ModelName = styled.h3`
    margin-top: 15px;
    font-size: 20px;
    letter-spacing: 2px;
    text-transform: uppercase;
    font-weight: 500;
    color: #111;
`;

export const ModelInfo = styled.div`
    text-align: center;
`;


//Italo//

export const Container = styled.div`
    max-width: 500px;
    margin: auto;
    background: #b5b09b;
`;

export const MainImage = styled.img`
    width: 100%;
    object-fit: cover;
    background: #b5b09b;
`;

export const Info = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 10px;
`;

export const TitleItalo = styled.h3`
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 1px;
    color: #111;
    margin-left: 20px;
`;

export const SubtitleItalo = styled.p`
    font-size: 20px;
    color: #3d3d3d;
    letter-spacing: 2px;
    text-transform: uppercase;
    padding-left: 20px;
`;

export const ModelButton = styled.button`
    margin-top: 15px;
    margin-bottom: 15px;
    align-self: center;
    box-sizing: border-box;

    width: fit-content;
    
    padding: 20px 40px;
    background: transparent;
    color: #111;
    border: 1px solid #111;

    font-size: 16px;
    letter-spacing: 2px;
    text-transform: uppercase;
    font-weight: 500;

    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        background: #111;
        color: #fff;
    }

    &:active {
        transform: scale(0.95)
    }
`;

export const Thumbnails = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 10px;
    overflow-x: auto;
    margin-left: 5px;
    margin-right: 5px;

    //Scroll//
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;

    //UX tactil//
    padding-bottom: 5px;

    //Ocultar scrollbar//
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display: none;
    }

    scrollbar-width: none;
    &::-webkit-scrollbar {
        display: none;
    }
`;

export const Thumbnail = styled.img`
    width: 80px;
    min-width: 80px;
    cursor: pointer;
    border-radius: 5px;
    box-sizing: border-box;

    scroll-snap-align: start;

    box-sizing: border-box;
    border: ${( props ) =>
        props.active ? "2px solid black" : "1px solid #ccc"};
    transition: 0.2s;

    &:hover {
        transform: scale(1.05);
    }
`;

export const ToggleButtonTrajes = styled.button`
    position: absolute;
    top: 25px;
    right: 30px;
    z-index: 6;

    background: transparent;
    border: 1px solid ${({ collapsed }) => (collapsed ? "#ffffff" : "#ffffff")};
    color: ${({ collapsed }) => (collapsed ? "#ffffff" : "#ffffff")};

    font-size: 1.5rem;
    padding: 8px 12px;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
        background: ${({ collapsed}) => (collapsed ? "#bbbbbb" : "#bbbbbb")};
        color: ${({ collapsed }) => (collapsed ? "#000000" : "#000000")};
    }
`;

export const ToggleButtonItalo = styled.button`
    position: absolute;
    top: 25px;
    right: 30px;
    z-index: 6;

    background: transparent;
    border: 1px solid ${({ collapsed }) => (collapsed ? "#ffffff" : "#2e2e2e")};
    color: ${({ collapsed }) => (collapsed ? "#ffffff" : "#2e2e2e")};

    font-size: 1.5rem;
    padding: 8px 12px;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
        background: ${({ collapsed}) => (collapsed ? "#bbbbbb" : "#bbbbbb")};
        color: ${({ collapsed }) => (collapsed ? "#000000" : "#000000")};
    }
`;

export const ArrowLeftStyle = styled.button`
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;

    background: rgba(0,0,0,0.5);
    color: #fff;
    border: none;
    padding: 10px;
    cursor: pointer;

    @media (max-width: 768px) {
        display: none;
    }
`;

export const ArrowRightStyle = styled(ArrowLeftStyle)`
    left: auto;
    right: 10px;
`;